import React from "react";
import { Box, Typography } from "@mui/material";

export default function LogLine({ title, val, isWarning }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 1.5,
        bgcolor: "rgba(234,240,248,0.02)",
        borderRadius: 2,
        borderLeft: "4px solid",
        borderColor: isWarning ? "error.main" : "primary.main",
      }}
    >
      <Typography variant="caption" color="text.secondary" fontWeight="600">
        {title}
      </Typography>
      <Typography
        variant="caption"
        fontFamily="monospace"
        fontWeight="bold"
        color={isWarning ? "error.light" : "text.primary"}
      >
        {val}
      </Typography>
    </Box>
  );
}
